// extracted by mini-css-extract-plugin
module.exports = {"input":"Input_input__CD_vq","error":"Input_error__gzMmX"};